module.exports = __webpack_public_path__ + "static/media/tiphogar.63e61937.svg";